// import * as Sentry from "@sentry/browser";
// import * as Integrations from "@sentry/integrations";
import axios from "axios";
import moment from "moment-timezone";
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueApexCharts from "vue-apexcharts";
import VueAxios from "vue-axios";
import VueCookie from "vue-cookie";
import VueI18n from "vue-i18n";
import VueMeta from "vue-meta";
import VueMoment from "vue-moment";
import App from "./App.vue";
import Blank from "./layouts/Blank.vue";
import Default from "./layouts/Default.vue";
import "./registerServiceWorker";
import router from "./router/router.js";
import store from "./store";
// import VueSocketIO from 'vue-socket.io'
// import SocketIO from "socket.io-client"
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueDragDrop from "vue-drag-drop";
import VueScrollPicker from "vue-scroll-picker";
import WebRTC from "vue-webrtc";

// Sentry.init({
//     dsn: "https://dd1677be70234abdafc9acf27d4cace0@sentry.cloudhosted.io/38",
//     integrations: [
//         new Integrations.Vue({
//             Vue,
//             attachProps: true,
//             logErrors: true,
//         }),
//     ],
//     environment: process.env.NODE_ENV || "development",
// });

Vue.use(VueDragDrop);
Vue.use(VueScrollPicker);

// import * as io from 'socket.io-client'
// window.io = io
// TODO: make locale appropriate to user
moment.locale("ka");

Vue.use(VueI18n);
Vue.use(VueMeta);
Vue.use(VueAxios, axios);
Vue.use(VueCookie);
Vue.use(VueMoment, {
    moment,
});
// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: 'wss://api-staging.mydoc.chat/ws',
//     vuex: {
//         store,
//         actionPrefix: 'SOCKET_',
//         mutationPrefix: 'SOCKET_'
//     },
//     options: { path: "/my-app/" } //Optional options
// }))
Vue.use(WebRTC);

Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component("default-layout", Default);
Vue.component("blank-layout", Blank);

Vue.filter("log", (val) => console.debug(val));

function setOnPushState(history) {
    var pushState = history.pushState;
    history.pushState = function (state) {
        if (typeof history.onpushstate === "function") {
            history.onpushstate({ state: state });
        }
        return pushState.apply(history, arguments);
    };
}
setOnPushState(window.history);

// window.OneSignal = window.OneSignal || []
// window.OneSignal.push(() => {
//   window.OneSignal.init({
//     appId: process.env.VUE_APP_ONESIGNAL
//   })
// })

// deploy once more to check for env var updates
window.OneSignal = window.OneSignal || [];
window.OneSignal.push(function () {
    window.OneSignal.init({
        appId: process.env.VUE_APP_ONESIGNAL,
    });
});

Vue.config.productionTip = false;
const i18n = new VueI18n({
    locale: "ka", // TODO: locale should depend on user preferences
    fallbackLocale: "en",
});
Vue.axios.defaults.baseURL =
    process.env.VUE_APP_BASE_URL || "https://api-staging.mydoc.chat";
Vue.use(VueAnalytics, {
    id: "UA-104613264-4",
    ecommerce: {
        enabled: true,
        enhanced: true,
    },
    router,
});
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
